// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var base = Curry._1(Css.style, /* [] */0);

var Styles = {
  base: base
};

var _map = {"horizontal":"horizontal","vertical":"vertical","both":"both"};

function flipToJs(param) {
  return param;
}

function flipFromJs(param) {
  return _map[param];
}

var _map$1 = {"left":"left","right":"right"};

function pullToJs(param) {
  return param;
}

function pullFromJs(param) {
  return _map$1[param];
}

function makeProps(className, flip, onClick, pull) {
  var arg = BrowserStyle.Utils.extendBaseStyle(base, className);
  var arg$1 = Relude_Option.map(flipToJs, flip);
  var arg$2 = Relude_Option.map(pullToJs, pull);
  var arg$3 = Relude_Option.map((function (onClick) {
          return function (param) {
            return Relude_Globals.$great$great(onClick, IOUtils.unsafeRunHandledAsync, param);
          };
        }), onClick);
  return function (param) {
    return function (param$1, param$2) {
      var func = function (param$3, param$4, param$5, param$6, param$7, param$8, param$9, param$10) {
        var tmp = {
          className: arg,
          icon: param$2
        };
        if (param !== undefined) {
          tmp.border = Caml_option.valFromOption(param);
        }
        if (param$1 !== undefined) {
          tmp.fixedWidth = Caml_option.valFromOption(param$1);
        }
        if (arg$1 !== undefined) {
          tmp.flip = Caml_option.valFromOption(arg$1);
        }
        if (param$3 !== undefined) {
          tmp.inverse = Caml_option.valFromOption(param$3);
        }
        if (param$4 !== undefined) {
          tmp.listItem = Caml_option.valFromOption(param$4);
        }
        if (param$5 !== undefined) {
          tmp.pull = Caml_option.valFromOption(param$5);
        }
        if (param$6 !== undefined) {
          tmp.pulse = Caml_option.valFromOption(param$6);
        }
        if (param$7 !== undefined) {
          tmp.rotation = Caml_option.valFromOption(param$7);
        }
        if (param$8 !== undefined) {
          tmp.spin = Caml_option.valFromOption(param$8);
        }
        if (param$9 !== undefined) {
          tmp.onClick = Caml_option.valFromOption(param$9);
        }
        return tmp;
      };
      return function (param, param$1, param$2, param$3, param$4) {
        return Curry._7(func, param, param$1, arg$2, param$2, param$3, param$4, arg$3);
      };
    };
  };
}

exports.Styles = Styles;
exports.flipToJs = flipToJs;
exports.flipFromJs = flipFromJs;
exports.pullToJs = pullToJs;
exports.pullFromJs = pullFromJs;
exports.makeProps = makeProps;
/* base Not a pure module */
